export const openConfirmationModal = (params) => ({
  type: 'CONFIRMATION_MODAL_OPEN',
  params,
});

export const closeConfirmationModal = () => ({
  type: 'CONFIRMATION_MODAL_CLOSE',
});
